import {FC, useState, useEffect} from 'react'
import Button from 'react-bootstrap/Button'
import {Modal} from 'react-bootstrap'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import {toast} from 'react-toastify'

const api = new Api()

type Props = {
  showFormModal: boolean
  handleCloseFormModal: any
  formData: any
}

const FormPage: FC<Props> = ({showFormModal, handleCloseFormModal, formData}) => {
  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false)
  const [formValue, setFormValue] = useState<any>({})
  const [dataRole, setDataRole] = useState<any>([])
  const [errors, setErrors] = useState<any>({})

  useEffect(() => {
    setShow(showFormModal)

    if (showFormModal) {
      fetchDataRole()
    }

    if (formData) {
      setFormValue(formData)
    }
  }, [showFormModal])

  const fetchDataRole = (params = {}) => {
    api
      .getRole({...params})
      .then((response: any) => {
        const data = response.data.data
        setDataRole(data)
      })
      .catch((error: any) => {
      })
  }

  const handleInput = (e: any, name: string) => {
    setFormValue({...formValue, [name]: e.target.value})
  }

  const handleClose = () => {
    setFormValue({})
    handleCloseFormModal(false)
    setShow(false)
    setErrors({})
  }

  const store = () => {
    setLoading(true)
    api
      .addRole(formValue)
      .then((response: any) => {
        setLoading(false)
        toast.success(response?.data?.meta?.message)
        handleClose()
      })
      .catch((error: any) => {
        setLoading(false)
        const {data} = error.response
        setErrors(data?.meta?.error)
      })
  }

  const update = () => {
    setLoading(true)
    api
      .updateRole(formValue, formValue?.id_hash)
      .then((response: any) => {
        setLoading(false)
        toast.success(response?.data?.meta?.message)
        handleClose()
      })
      .catch((error: any) => {
        setLoading(false)
        const {data} = error.response
        setErrors(data?.meta?.error)
      })
  }

  const handleSubmit = () => {
    if (formValue?.id_hash) {
      update()
      return
    }

    store()
  }

  return (
    <Modal show={show} size='lg' onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{formValue?.id ? 'Edit' : 'Tambah'} Role</Modal.Title>
      </Modal.Header>
      <div>
        <Modal.Body>
          <div className='row'>
            <div className='col-md-12'>
              <p>Nama Role</p>
              <input
                type='text'
                className={`form-control mt-2 ${errors?.name ? 'border-danger' : ''}`}
                value={formValue?.name}
                onChange={(e) => handleInput(e, 'name')}
              />

              {errors?.name ? <p className='text-danger mt-1'>{errors?.name}</p> : null}
            </div>

            <div className='col-md-12 mt-5'>
              <p>Deskripsi</p>
              <input
                type='text'
                className={`form-control mt-2 ${errors?.description ? 'border-danger' : ''}`}
                value={formValue?.description}
                onChange={(e) => handleInput(e, 'description')}
              />

              {errors?.description ? (
                <p className='text-danger mt-1'>{errors?.description}</p>
              ) : null}
            </div>

            <div className='col-md-12 mt-5'>
              <p>Status</p>
              <select
                name='status'
                className={`form-control mt-2 ${errors?.is_active ? 'border-danger' : ''}`}
                value={formValue?.is_active ?? ''}
                onChange={(e) => handleInput(e, 'is_active')}
              >
                <option value=''>--Pilih Status--</option>
                <option value='1'>Aktif</option>
                <option value='0'>Nonaktif</option>
              </select>
              {errors?.is_active ? <p className='text-danger mt-1'>{errors?.is_active}</p> : null}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type='button' variant='secondary' onClick={handleClose} disabled={loading}>
            Batalkan
          </Button>
          <Button variant='primary' type='button' disabled={loading} onClick={handleSubmit}>
            {loading ? 'Loading' : 'Simpan'}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  )
}

const FormModal: FC<Props> = ({showFormModal, handleCloseFormModal, formData}) => {
  return (
    <FormPage
      showFormModal={showFormModal}
      handleCloseFormModal={handleCloseFormModal}
      formData={formData}
    />
  )
}

export default FormModal
